import React, { PureComponent } from "react";
import { Form, Button, Col, Row, message } from "antd";
import mes1 from "images/edu/mes1.png";
import message01 from "images/soldier/message1.png";
import { Link } from "react-router-dom";
import Request from "../../networkReq/request";
import Http from "../../networkReq/http";
import { getCurrentUser } from "utils/storage";
import {getStatus} from "@/utils/methods";
import ApproveModal from '@/components/ApproveModal'
const FormItem = Form.Item;
require("./eduOrganizationDetail.scss");
export default class DeucationTrainingPolicyDetail extends PureComponent {
  state = {
    sourseId: "",
    courseInfo: {},
  };
  componentDidMount() {
    this.modalRef = React.createRef();
    console.log(
      "看一下有哪些信息",
      this.props.location.pathname.split("/").slice(-1)
    );
    let sourseId = this.props.location.pathname.split("/").slice(-1);
    this.getDetail(sourseId[0]);
    this.setState({ sourseId: sourseId[0] });
  }
  //获取详情
  getDetail = (data) => {
    console.log("id信息", data);
    let params = {
      id: data,
    };
    Http.getApplication(Request.eduDetail(), { ...params }, (obj) => {
      console.log(obj);
      if (obj.code == 200) {
        this.setState({
          courseInfo: obj.data,
          //    courseList:obj.data.records
        });
      }
    });
  };

  renderBaesInfo = (data) => {
    if (data && data.length) {
      return data.map((item, index) => {
        return (
          <Col span={12} key={index}>
            <FormItem label={item.name}>{item.value}</FormItem>
          </Col>
        );
      });
    }
  };
  getApply = () => {
    message.config({
      top: 50,
      duration: 1,
      maxCount: 1
    });
    const { sourseId } = this.state;
    if (!getCurrentUser()) {
      message.error("还未登录，请先登录后报名！");
      return;
    }

    if(getCurrentUser().user_type!=="2"){
      message.warn("非退役军人不可报名",[1])
      return;
    }
    getStatus().then(res=>{
      if(res===false){
        this.modalRef.current.showModal();
          return;
      }
    Http.getApplication(Request.getApply(), { id: sourseId }, (obj) => {
      if (obj.code == 200) {
        // this.setState({TraList:obj.data})
        message.success(obj.msg);
      } else {
        message.error(obj.msg);
      }
      // this.setState({isModalVisible:false})
    });
  })
  };
  render() {
    const { courseInfo } = this.state;
    const courseList = [
      {
        name: "机构名称",
        value: courseInfo ? courseInfo.trainingName : "",
      },
      {
        name: "培训行业",
        value: courseInfo ? courseInfo.courseType : "",
      },
      {
        name: "培训地点",
        value: courseInfo ? courseInfo.trainingIocations : "",
      },
      {
        name: "培训方式",
        value: "线下",
      },
      {
        name: "主讲教师",
        value: courseInfo ? courseInfo.jsName : "",
      },
      {
        name: "是否需要参加结业考试",
        value: courseInfo ? courseInfo.examination == 1 ? "否" : "是":'',
      },
      {
        name: "联系方式",
        value: courseInfo.courseTel,
      },
      {
        name: "是否颁发结业证书",
        value: courseInfo? courseInfo.certificate == 1 ? "否" : "是":'',
      },
    ];

    return (
      <div className="eduOrgDetail">
        <div className="conBox">
          <div className="topbox">
            <div className="left">
              <img src={courseInfo.courseUrl} alt="" />
            </div>
            <div className="right">
              <div className="courseInfoBox">
                <span className="courseName">{courseInfo.courseName}</span>
                <span className="btnBox">
                  <Button
                    type="primary"
                    className="leftBtn"
                    onClick={this.getApply}
                  >
                    报名学习
                  </Button>
                  <Button onClick={this.props.history.goBack}>返回</Button>
                </span>
              </div>
              <div className="courseInfoList">
                <Form
                // labelCol={{ span: 8 }}
                // wrapperCol={{ span: 16 }}
                >
                  <Row gutter={[24, 2]}>
                    {courseInfo ? this.renderBaesInfo(courseList) : ""}
                  </Row>
                </Form>
              </div>
            </div>
          </div>
          <div className="btoBox">
            <div className="eduDetailInfo">
              <h2>机构简介</h2>
              <p>{courseInfo.trainingIntroduce}</p>
            </div>
            <div className="eduDetailInfo">
              <h2>培训时间</h2>
              <p>{courseInfo.trainingTime}</p>
              {/* <p>周四到周五上午08:00--12:00</p> */}
            </div>
            <div className="eduDetailInfo">
              <h2>机构荣誉资质</h2>
              {/* <p>{courseInfo.trainingFaculty}</p> */}
              {
                courseInfo.photoList && courseInfo.photoList.map((item)=>{
                  return <img style={{width:400,margin:10}} src={item.photoUrl}></img>
                })
              }
              {/* <p>具备高级工程师职称28名</p>
                            <p>具备一级消防工程师职称9名</p> */}
            </div>
            {/* <div className="eduDetailInfo">
              <h2>机构荣誉资讯</h2>
              <div className="imgList">
                <img src={message01} alt="" />
                <img src={message01} alt="" />
                <img src={message01} alt="" />
                <img src={message01} alt="" />
                <img src={message01} alt="" />
                <img src={message01} alt="" />
              </div>
            </div> */}
          </div>
          <ApproveModal ref = {this.modalRef}/>
        </div>
      </div>
    );
  }
}
